import type { Dictionary } from './types';

export const vi: Dictionary = {
  page_title: 'AI-DLC Framework',
  page_subtitle: 'Luồng triển khai giữa NxKMS — AgentSkills Hub — Project Deployment',

  la_badge: 'Tầng A',
  la_sub: 'Hệ thống quản lí tri thức doanh nghiệp — chuẩn hóa mọi nguồn kiến thức thành Knowledge Nodes',
  la_src_label: 'Nguồn tri thức đầu vào',
  la_s1_t: 'Upload File', la_s1_d: 'Docs, PDF, MD từ dự án',
  la_s2_t: 'Google Drive', la_s2_d: 'Sync tự động theo folder',
  la_s3_t: 'Notion / Slack', la_s3_d: 'Tài liệu nội bộ & thảo luận',
  la_s4_t: 'Repo / Wiki', la_s4_d: 'CLAUDE.md, AGENTS.md',
  la_flow_label: 'Luồng xử lý nội bộ — tương tác của team',
  la_f1: 'Upload & ingest', la_f2: 'Chuẩn hóa → Knowledge Node',
  la_f3: 'Semantic indexing', la_f4: 'Domain tagging',
  la_f5: 'Tìm kiếm ngữ nghĩa', la_f6: 'Định hướng dự án → gợi ý Skills',
  la_f7: 'Liên kết đến AgentSkills Hub',
  la_m1_t: 'Knowledge Repository',
  la_m1_d: 'Tập trung tài liệu từ upload file & GDrive — chuẩn hóa thành Knowledge Node theo domain dự án',
  la_m2_t: 'Project Advisor',
  la_m2_d: 'Gợi ý Skills phù hợp theo tech stack, domain, loại dự án khi khởi động',
  la_uflow_label: 'Luồng người dùng — admin cấu hình, thành viên dự án chat',
  la_uflow_admin_t: 'Phía Admin',
  la_uflow_user_t: 'Phía thành viên dự án',
  la_uflow_admin_steps: [
    'Tải lên nguồn tri thức',
    'Gắn tag theo dự án / domain',
    'Tạo chatbot (chung hoặc theo tri thức)',
    'Phát hành nội bộ',
  ],
  la_uflow_user_steps: [
    'Mở cổng NxKMS',
    'Chọn chatbot dự án',
    'Đặt câu hỏi bằng ngôn ngữ tự nhiên',
    'Nhận câu trả lời có trích dẫn',
  ],
  la_ui_demo_label: 'Xem trước — giao diện chatbot dự án',
  la_ui_sidebar_t: 'Chatbot dự án',
  la_ui_bots: [
    { name: 'Fintech Payment Bot', desc: 'Chuyên gia domain PCI-DSS', active: true },
    { name: 'Legacy Migration Bot', desc: 'Context COBOL → Java' },
    { name: 'Trợ lý NTQ tổng quát', desc: 'Hỏi đáp toàn công ty' },
    { name: 'Monitoring / SRE Bot', desc: 'onTune, Beyla, Prometheus' },
  ],
  la_ui_user_msg: 'Luồng thanh toán của chúng ta xử lý lỗi 3DS challenge cho khách hàng JP như thế nào?',
  la_ui_bot_msg: 'Theo PRD-023-payment.md và spec tích hợp SBPayment, lỗi 3DS được route qua retry queue với giới hạn 2 lần. Với khách hàng JP còn kích hoạt cờ fraud-review theo quy tắc compliance Fintech.',
  la_ui_sources_t: 'Nguồn',
  la_ui_sources: ['PRD-023-payment.md', 'sbpayment-integration.md', 'fintech-rules.md'],
  la_ui_input_ph: 'Hỏi về dự án này...',

  conn_ab_dn: 'Gợi ý Skills theo context dự án',
  conn_ab_up: 'Skills verified → enrich Knowledge Base',
  conn_ab_dn_note: 'NxKMS phân tích domain dự án và đề xuất bộ Skills phù hợp nhất cho team — tự động khi khởi động dự án.',
  conn_ab_up_note: 'Mọi Skill sau khi được review & publish đều được đánh tag domain và bổ sung vào Knowledge Base của NxKMS — giúp các dự án sau tìm kiếm chính xác hơn.',

  lb_badge: 'Tầng B',
  lb_sub: 'Nền tảng tổng hợp, quản trị & phân phối AI Skills — cho mọi dự án NTQ',
  lb_official_t: 'Official Skills — verified từ makers',
  lb_official_d: 'Từ các tổ chức & công ty xây dựng công nghệ — đã kiểm chứng, đồng bộ bởi đội phát triển NTQ',
  lb_see_more: 'Xem thêm 40+ creators',
  lb_see_less: 'Ẩn bớt',
  lb_ntq_t: 'NTQ Customized Skills',
  lb_ntq_d: 'Theo tech stack, domain, role — build & maintain bởi NTQ Cloud team',
  lb_pkg_t: 'Skills Set / Package cho dự án đặc thù',
  pkg1_t: 'Fintech Package', pkg2_t: 'Legacy Migration', pkg3_t: 'Monitoring / SRE', pkg4_t: 'ISO 27001 / SOC2',
  lb_gov_label: 'Governance & chất lượng skill',
  lb_gov_steps: ['Skill Author tạo skill', 'Reviewer kiểm tra', 'Approve & version', 'Publish lên Hub', 'Usage analytics'],
  lb_flow_label: 'Luồng tương tác của team trong Hub',
  lb_f1: 'Tìm skill theo domain / role', lb_f2: 'Install qua CLI (skills.sh)', lb_f3: 'Cập nhật CLAUDE.md',
  lb_f4: 'Admin: quản lý policy & access', lb_f5: 'Theo dõi adoption rate', lb_f6: 'Đề xuất skill mới từ dự án',
  lb_persona_label: 'Personas',
  lb_p1: 'Skill Author — BA / Architect / Senior Dev',
  lb_p2: 'Skill Consumer — Dev / QA / PM',
  lb_p3: 'Reviewer / Team Lead',
  lb_p4: 'Enterprise Admin',
  lb_uflow_label: 'Luồng người dùng — từ duyệt đến đã cài vào IDE',
  lb_uflow_steps: [
    'Tìm theo tech / domain / role',
    'Xem chi tiết skill',
    'Cài qua CLI (skills.sh)',
    'Commit .claude/skills vào repo',
    'Cả team pull & sử dụng',
  ],
  lb_ui_demo_label: 'Xem trước — skills marketplace',
  lb_ui_search_ph: 'Tìm skills...',
  lb_ui_filter_label: 'Lọc',
  lb_ui_filter_chips: ['Fintech', 'Java Spring', 'Vue / React', 'Bảo mật', 'Monitoring'],
  lb_ui_cards: [
    { name: 'fintech-payment', tag: 'NTQ · Domain', desc: 'Payment handler chuẩn PCI-DSS có audit log pattern', downloads: '1.2k lượt cài' },
    { name: 'spring-boot-3', tag: 'Official · Java', desc: 'Quy ước Spring Boot 3.x: Security, JPA, error handlers', downloads: '3.4k lượt cài' },
    { name: 'pr-checklist', tag: 'NTQ · Review', desc: 'Checklist tự review trước merge + phát hiện code smell kiến trúc', downloads: '5.8k lượt cài' },
    { name: 'playwright-e2e', tag: 'Official · Testing', desc: 'Sinh test Playwright kèm fixtures & retry logic', downloads: '2.7k lượt cài' },
  ],
  lb_ui_install_t: 'Cài đặt',
  lb_ui_install_hint: 'Copy lệnh này để cài vào dự án',

  conn_bc_dn: 'Install skills vào agent / IDE của dự án',
  conn_bc_up: 'Contribute skills đúc kết từ thực tế',
  conn_bc_dn_note: 'Tech Lead chọn Skills phù hợp từ Hub, chạy lệnh install vào .claude/skills/ — toàn team dùng chung qua git clone.',
  conn_bc_up_note: 'Dev / BA phát hiện best practice mới trong dự án — đóng gói thành Skill mới — submit lên AgentSkills Hub để các dự án khác dùng lại.',

  lc_badge: 'Tầng C',
  lc_title: 'Project Deployment — AI-DLC In Practice',
  lc_sub: 'Vận hành dự án thực tế theo AI-DLC framework — mỗi dự án là vòng lặp cải tiến liên tục',
  lc_steps_label: '10 bước triển khai — nhấn vào bước để xem nội dung deck',
  lc_steps: ['Knowledge Foundation', 'Project Structure', 'IDE Mapping', 'Bootstrap', 'Daily Dev Loop', 'Testing', 'Team Standards', 'Security', 'I/O Map', 'Continuous Improvement'],
  lc_steps_th: ['Bước', 'Tên', 'Vai trò chính', 'AI làm gì', 'Output'],
  lc_steps_data: [
    ['S1', 'Knowledge Foundation', 'Tech Lead / BA', 'Chuẩn hóa tài liệu thô sang Markdown; soạn thảo CLAUDE.md/AGENTS.md; xây dựng docs/context để chất lượng output AI = chất lượng kiến thức được cung cấp', 'CLAUDE.md, AGENTS.md, docs/ folder'],
    ['S2', 'Project Structure', 'Tech Lead', 'Định nghĩa cây thư mục .claude/ (rules, skills, commands), cấu trúc docs/, quy ước đặt tên và registry skills/workflows dùng chung', '.claude/, docs/requirements, docs/architecture committed'],
    ['S3', 'IDE Mapping', 'Dev Team', 'Ánh xạ cùng một khái niệm trên Claude Code · Cursor · Windsurf (rules, commands, hooks, MCP); chuẩn hóa một IDE duy nhất cho cả team', 'settings.json, .cursor/rules/, .windsurfrules'],
    ['S4', 'Bootstrap', 'Tech Lead + AI', 'AI chạy /init để scan codebase → soạn CLAUDE.md/AGENTS.md; cài đặt & tùy chỉnh base skills; định nghĩa /feature /fix /review commands', 'CLAUDE.md v1, .claude/skills, .claude/commands'],
    ['S5', 'Daily Dev Loop', 'PM/BA · Dev · AI · CI', 'Ticket → /onboard → task file → /feature (plan + TDD + hooks) → tự review → human diff review → CI → PR ready; các luồng con cho specs, coding, hỏi đáp, review, debug, planning', 'Task file log, code + tests, PR ready'],
    ['S6', 'Testing', 'QA / Dev', 'Ba luồng: Unit Test (/test), E2E Playwright (/e2e), Requirement-first (/test-plan từ PRD acceptance criteria)', 'Test plan, .test.ts, .spec.ts, coverage report'],
    ['S7', 'Team Standards', 'Tech Lead / Reviewer', '4 tầng: Source of truth · Gold-standard examples · Hooks+CI enforcement · Skill/Docs PR process — loại bỏ tình trạng "3 dev, 3 phong cách"', 'team-ai-standards/, gold-standard/, Output Consistency Checklist'],
    ['S8', 'Security', 'Security Lead / Dev', '6 tầng bảo vệ (kiến trúc · git · permissions settings.json · hooks · CI · rules); rules/security.md bắt buộc dùng process.env + tự scan sk-/api_key/password', '.gitignore, deny rules, gitleaks CI, security-hook.sh'],
    ['S9', 'I/O Map', 'BA / Tech Lead', 'Bảng theo giai đoạn: Human Input · AI thực hiện · Human Gate · Output cho Knowledge Foundation → Bootstrap → Intake → Design → Implement → Test → Deploy → Improve', 'I/O diagram (Markdown), API contract'],
    ['S10', 'Continuous Improvement', 'Tất cả role', 'Không theo lịch cố định — kích hoạt theo sự kiện: AI lặp lại lỗi, dev giải thích cùng context, tìm ra pattern tốt hơn, công cụ mới, sự cố — cập nhật skill/rule ngay lập tức', 'CLAUDE.md đã cập nhật, skills mới lên Hub, docs vào NxKMS'],
  ],
  lc_flow_label: 'Luồng tương tác team trong dự án',
  lc_f1: 'Tìm skill từ Hub', lc_f2: 'Install & config IDE', lc_f3: 'AI agent thực thi', lc_f4: 'Dev / QA review',
  lc_f5: 'Query NxKMS khi cần ref', lc_f6: 'Iterate & cải tiến skill', lc_f7: 'Đóng góp skill ngược lên Hub',
  lc_m1_t: 'Trong khi vận hành',
  lc_m1_d: 'Team phát hiện pattern mới — draft skill — submit lên Hub để review',
  lc_m2_t: 'Sau khi kết thúc dự án',
  lc_m2_d: 'Retrospective — đúc kết lessons learned — đóng gói thành skill hoặc knowledge node',
  lc_contrib: 'Mọi role (Dev, BA, QA, PM) đều có thể đóng góp skills lên AgentSkills Hub và tài liệu vào NxKMS — tạo vòng lặp cải tiến liên tục cho toàn NTQ',

  leg_a: 'NxKMS (tri thức)', leg_b: 'AgentSkills Hub (skills)', leg_c: 'Project Layer (thực thi)', leg_flow: 'Luồng xuôi',

  ntq_cat_tech: 'Theo Tech Stack',
  ntq_cat_domain: 'Theo Domain dự án',
  ntq_cat_role: 'Theo Role',
  ntq_tags_tech: [
    { t: 'AWS / Azure', s: 'IaC, Lambda, AKS' },
    { t: 'Java Spring', s: 'Boot 3.x, Security' },
    { t: 'Vue / React', s: 'Vue 3, Next.js 14' },
    { t: 'Go backend', s: 'Gin, gRPC, Ent' },
    { t: 'C# .NET', s: 'Core 8, EF' },
    { t: 'Node.js', s: 'Express, Fastify' },
    { t: 'Python', s: 'FastAPI, Django' },
    { t: 'Mobile', s: 'Flutter, Expo' },
  ],
  ntq_tags_domain: [
    { t: 'Fintech', s: 'PCI-DSS, payment' },
    { t: 'Healthcare', s: 'HIPAA, EHR' },
    { t: 'E-commerce', s: 'Shopify, Cart' },
    { t: 'Legacy Migration', s: 'COBOL → Java' },
    { t: 'Monitoring / SRE', s: 'onTune, Beyla' },
    { t: 'Edtech', s: 'LMS, KT' },
    { t: 'JP Enterprise', s: 'SBPayment, Bajie' },
    { t: 'KR Enterprise', s: 'onTune, WhaTap' },
  ],
  ntq_tags_role: [
    { t: 'BA', s: 'Requirement, spec' },
    { t: 'PM / PO', s: 'Roadmap, risk' },
    { t: 'Dev', s: 'Code, review' },
    { t: 'QA / Tester', s: 'Playwright, test plan' },
    { t: 'DevOps', s: 'CI/CD, IaC' },
    { t: 'Security Lead', s: 'OWASP, audit' },
    { t: 'Tech Lead', s: 'Architecture, skill' },
    { t: 'Designer', s: 'Figma, hand-off' },
  ],

  access_title: 'Team dự án truy cập như thế nào?',
  access_desc: 'Nhân sự dự án có thể truy cập từ <span class="access-pill access-pill-a">NxKMS</span> để tìm tri thức và được gợi ý Skills, hoặc truy cập trực tiếp <span class="access-pill access-pill-b">AgentSkills Hub</span> để tìm, cài và quản lý Skills — cả hai con đường đều dẫn về một hệ sinh thái thống nhất.',
  access_or: 'hoặc',
  access_path_a_label: 'NxKMS',
  access_path_a_desc: 'Tìm kiếm tri thức doanh nghiệp và nhận Skills được AI đề xuất cho dự án',
  access_path_a_badge: 'Con đường tri thức',
  access_path_b_label: 'AgentSkills Hub',
  access_path_b_desc: 'Duyệt, cài đặt và quản lý AI Skills trực tiếp cho IDE và dự án',
  access_path_b_badge: 'Con đường Skills',
  access_note: 'Cả hai con đường đều dẫn về một hệ sinh thái thống nhất.',

  footer_copy: '© 2026 NTQ Solution JSC — AI-DLC Framework. All rights reserved.',
  footer_version: 'v1.0',

  step_panel_prev: '‹ Bước trước',
  step_panel_next: 'Bước sau ›',
  step_panel_close: 'Đóng ✕',
  step_panel_open_hint: 'Nhấn vào bước bên trên để xem nội dung deck',

  deck: {
    s0_title: 'AI-DLC In Practice',
    s0_sub: 'Cách hoạt động thực tế trong dự án của bạn — từng bước một',
    s0_msg: '"AI-DLC không bắt đầu bằng code. Nó bắt đầu bằng việc chuẩn hóa kiến thức thành tài liệu. Mọi thứ khác đều phụ thuộc vào nền tảng đó."',

    s1_title: 'Knowledge Foundation',
    s1_sub: 'Bước quan trọng nhất — thường bị bỏ qua',
    s1_msg: 'Chất lượng output AI = chất lượng kiến thức được cung cấp',
    s1_col1_t: 'Kiến thức thô',
    s1_col2_t: 'Chuẩn hóa →',
    s1_col3_t: 'Input sẵn sàng cho AI',
    s1_col1: [
      'Codebase không có tài liệu',
      'Wiki, email, ghi chú họp',
      'Quyết định kỹ thuật chỉ trong đầu người',
      'Business rules chỉ PM biết',
    ],
    s1_col2: [
      'Toàn bộ nội dung → Markdown (.md)',
      'Cấu trúc heading rõ ràng H1→H2→H3',
      'Sơ đồ bằng Mermaid (có thể versioning)',
      'Tên có ý nghĩa: PRD-001-auth.md',
    ],
    s1_col3: [
      'CLAUDE.md / AGENTS.md < 200 dòng',
      'rules/ phân tách theo mối quan tâm',
      'skills/ — module theo yêu cầu',
      'docs/context/ — context riêng cho AI',
    ],

    s1b_title: 'Knowledge Foundation: Công cụ',
    s1b_sub: 'Công cụ được khuyến nghị giúp trích xuất kiến thức nhanh và đáng tin cậy',
    s1b_groups: [
      {
        title: 'Knowledge Graph — Khám phá & Trực quan hóa Code',
        color: '#4F46E5',
        tools: [
          {
            name: 'GitNexus',
            tag: 'Zero-server · Browser-native Knowledge Graph  ⚠ Yêu cầu custom parser',
            desc: 'Kéo thả GitHub repo hoặc ZIP — GitNexus xây dựng knowledge graph tương tác hoàn toàn trong trình duyệt. Tích hợp Graph RAG agent để hỏi đáp về code. Các ngôn ngữ không được hỗ trợ (COBOL, Delphi, custom DSL) cần viết custom tree-sitter parser trước.',
            usage: 'Dùng trước khi bắt đầu dự án mới. Viết custom parser cho bất kỳ ngôn ngữ/thư viện chưa được hỗ trợ.',
            url: 'github.com/abhigyanpatwari/GitNexus',
            color: '#4F46E5',
          },
          {
            name: 'Understand-Anything',
            tag: 'Claude Code Skill · Interactive Codebase Knowledge Graph',
            desc: 'Claude Code / Codex skill biến bất kỳ codebase nào thành knowledge graph tương tác. Đa nền tảng. Tìm kiếm, khám phá và đặt câu hỏi về quan hệ code và call chains.',
            usage: 'Dùng trong Claude Code qua lệnh /understand-anything để khám phá codebase theo thời gian thực.',
            url: 'github.com/Lum1104/Understand-Anything',
            color: '#0B8A75',
          },
          {
            name: 'Repomix',
            tag: 'CLI · Đóng gói toàn bộ repo thành file AI-readable',
            desc: 'Đóng gói toàn bộ codebase thành một file Markdown/XML tối ưu cho context window của LLM. Hỗ trợ .repomixignore, lọc bảo mật và đếm token. Lý tưởng để gửi toàn bộ context dự án cho AI trong một lần.',
            usage: 'Chạy repomix trước bất kỳ phiên AI nào cần nhận thức toàn bộ codebase. Thêm .repomixignore để loại trừ các file được sinh ra.',
            url: 'github.com/yamadashy/repomix',
            color: '#E6522C',
          },
          {
            name: 'code2prompt',
            tag: 'CLI · Source → prompt có cấu trúc với đầy đủ context',
            desc: 'Chuyển đổi file source code thành prompt có cấu trúc với syntax highlighting, tree view và metadata file. Hỗ trợ glob pattern để chọn file. Output tối ưu để copy-paste vào AI chat hoặc inject vào CLAUDE.md.',
            usage: 'Dùng để tạo prompt tập trung từ các module được chọn. Kết hợp với /feature để cung cấp context chính xác cho AI.',
            url: 'github.com/mufeedvh/code2prompt',
            color: '#F59E0B',
          },
        ],
      },
      {
        title: 'Chuyển đổi định dạng — Chuyển tài liệu thành tri thức AI có thể đọc',
        color: '#0078D4',
        tools: [
          {
            name: 'MarkItDown (Tùy chỉnh)',
            tag: 'Microsoft · PDF / DOCX / PPTX / Web → Markdown  ⚠ Phải tùy chỉnh theo từng dự án',
            desc: 'Phải được tùy chỉnh cho từng dự án — mỗi dự án có định dạng, cấu trúc phần và quy ước đặt tên khác nhau. Dự án Nhật Bản cần xử lý encoding (Shift-JIS/UTF-8), loại bỏ furigana và ánh xạ lại heading. Không có adapter thì Markdown output sẽ đánh lừa AI.',
            usage: 'Viết project adapter (convert_docs.py). Test trên 3–5 mẫu đại diện trước.',
            url: 'github.com/microsoft/markitdown',
            color: '#0078D4',
          },
          {
            name: 'Docling',
            tag: 'IBM · PDF / DOCX / HTML → Markdown có cấu trúc + JSON',
            desc: 'Parser mã nguồn mở của IBM với tính năng trích xuất bảng nguyên gốc, phát hiện hình ảnh và bảo toàn cấu trúc tài liệu. Xuất sang Markdown, JSON và định dạng Docling Document. Xử lý PDF scan với OCR tích hợp. Độ trung thực cấu trúc tốt hơn MarkItDown cho bố cục phức tạp.',
            usage: 'Dùng cho PDF có bảng hoặc hình ảnh phức tạp (hợp đồng, đặc tả, báo cáo). Kết hợp với pipeline chunking để nhập RAG.',
            url: 'github.com/DS4SD/docling',
            color: '#0062A3',
          },
          {
            name: 'Marker',
            tag: 'GPU-accelerated · PDF → Markdown chất lượng cao  ⚠ Cần GPU để chạy nhanh',
            desc: 'Bộ chuyển đổi PDF sang Markdown tiên tiến sử dụng mô hình phát hiện bố cục và OCR. Xử lý đa cột, chú thích, phương trình toán học và code block. Chất lượng tốt nhất cho tài liệu học thuật và tài liệu Nhật/Hàn phức tạp. Khuyến nghị GPU cho xử lý hàng loạt.',
            usage: 'Dùng cho PDF scan hoặc tài liệu mà MarkItDown mất cấu trúc. Chạy cục bộ với GPU để chuyển đổi hàng loạt.',
            url: 'github.com/VikParuchuri/marker',
            color: '#7C3AED',
          },
          {
            name: 'PyMuPDF4LLM',
            tag: 'PyMuPDF · PDF → Markdown nhanh với chunking nhận biết trang',
            desc: 'Thư viện Python xây dựng trên PyMuPDF để trích xuất PDF nhanh, chính xác với output tối ưu cho LLM. Hỗ trợ trích xuất theo trang, phát hiện header và bảo toàn hyperlink. Nhanh hơn đáng kể so với Marker cho PDF nhiều chữ không có bố cục phức tạp.',
            usage: 'Dùng làm trình trích xuất PDF mặc định cho tài liệu nhiều chữ. Chuyển sang Marker chỉ khi độ trung thực bố cục là quan trọng.',
            url: 'github.com/pymupdf/PyMuPDF',
            color: '#059669',
          },
        ],
      },
    ],
    s1b_flow: ['Nguồn (PDF/DOCX/Repo/URL)', 'Tùy chỉnh adapter theo dự án', 'Trích xuất & chuyển đổi', 'Cấu trúc & lập chỉ mục', 'Commit vào docs/context/'],
    s1b_note: '⚠ Tất cả công cụ đều cần tùy chỉnh theo từng dự án. Công cụ chuyển đổi định dạng cần adapter encoding/layout (đặc biệt tiếng Nhật). Công cụ knowledge graph cần custom parser cho ngôn ngữ chưa hỗ trợ. Luôn test trên 3–5 mẫu thực tế trước khi commit output.',

    s2_title: 'Project Structure',
    s2_sub: '.claude/ + docs/ — mỗi file có vị trí và mục đích riêng',
    s2_legend: [
      { type: 'always', label: 'Luôn tải' },
      { type: 'ondemand', label: 'Theo yêu cầu' },
      { type: 'manual', label: 'Kích hoạt thủ công' },
      { type: 'hooks', label: 'Hooks tự động' },
      { type: 'ide', label: 'Riêng IDE' },
    ],
    s2_tree: [
      { txt: 'project-root/', type: 'root' },
      { txt: '├── CLAUDE.md', type: 'always', note: 'Điểm vào dùng chung cho team — quy ước dự án, tech stack, quy tắc bắt buộc (< 200 dòng)' },
      { txt: '├── AGENTS.md', type: 'always', note: 'Biến thể tương thích đa IDE cho Cursor/Windsurf' },
      { txt: '├── CLAUDE.local.md', type: 'muted', note: 'Ghi đè cá nhân (gitignored)' },
      { txt: '├── .claude/', type: 'root' },
      { txt: '│   ├── rules/', type: 'always', note: 'Rules luôn bật, phân tách theo mối quan tâm (security, style, api)' },
      { txt: '│   ├── skills/', type: 'ondemand', note: 'Skills theo yêu cầu (api-handler, unit-test, ...)' },
      { txt: '│   ├── commands/', type: 'manual', note: '/feature /fix /review /deploy — slash commands' },
      { txt: '│   ├── agents/', type: 'ondemand', note: 'Sub-agents cho các luồng chuyên biệt' },
      { txt: '│   └── settings.json', type: 'hooks', note: 'Hooks (Pre/PostToolUse), quyền hạn, deny rules' },
      { txt: '├── .cursor/rules/', type: 'ide', note: 'Tương đương rules của Cursor (*.mdc)' },
      { txt: '├── .windsurfrules', type: 'ide', note: 'Rules toàn cục Windsurf' },
      { txt: '├── .mcp.json', type: 'ondemand', note: 'Cấu hình MCP server' },
      { txt: '├── docs/', type: 'root', note: 'Xem slide tiếp theo để biết chi tiết' },
      { txt: '└── src/ · tests/ · ...', type: 'muted', note: 'Code dự án tiêu chuẩn' },
    ],

    s2b_title: 'Cấu trúc thư mục docs/',
    s2b_sub: 'Chi tiết — mỗi thư mục con được giải thích cùng quy ước đặt tên',
    s2b_tree: [
      { txt: 'docs/', type: 'root' },
      { txt: '├── requirements/', type: 'always', note: 'File PRD — một file mỗi feature hoặc epic' },
      { txt: '│   ├── PRD-001-user-auth.md', type: 'always', note: 'Vấn đề + mục tiêu + AC + ngoài phạm vi' },
      { txt: '│   └── PRD-002-payments.md', type: 'always', note: 'Đặt tên: PRD-[số]-[tên-ngắn].md' },
      { txt: '├── architecture/', type: 'root' },
      { txt: '│   ├── decisions/', type: 'always', note: 'ADRs — bất biến sau khi được approve' },
      { txt: '│   │   ├── ADR-001-auth-strategy.md', type: 'always', note: 'Bối cảnh + Quyết định + Lựa chọn thay thế + Hệ quả' },
      { txt: '│   │   └── ADR-002-database.md', type: 'always', note: 'Đặt tên: ADR-[số]-[chủ đề].md' },
      { txt: '│   ├── api-contracts/', type: 'ondemand', note: 'API schemas theo domain' },
      { txt: '│   │   └── auth.md', type: 'ondemand', note: 'Cập nhật khi API endpoints thay đổi' },
      { txt: '│   └── system-overview.md', type: 'always', note: 'Kiến trúc tổng quan với sơ đồ Mermaid' },
      { txt: '├── tasks/', type: 'root' },
      { txt: '│   ├── active/', type: 'manual', note: 'Sprint hiện tại — AI ghi log session ở đây' },
      { txt: '│   │   └── TASK-101.md', type: 'manual', note: 'Mục tiêu + AC + context + test scenarios' },
      { txt: '│   └── done/', type: 'muted', note: 'Đã hoàn thành — chuyển sau khi merge' },
      { txt: '├── context/', type: 'ondemand', note: 'Kiến thức dài hạn riêng cho AI' },
      { txt: '│   ├── domain-glossary.md', type: 'ondemand', note: 'Thuật ngữ nghiệp vụ — ngăn AI hallucination' },
      { txt: '│   ├── known-issues.md', type: 'ondemand', note: 'Bug hiện tại và cách giải quyết' },
      { txt: '│   ├── business-rules.md', type: 'ondemand', note: 'Quy tắc chỉ PM/BA biết' },
      { txt: '│   └── tool-changelog.md', type: 'ondemand', note: 'Khi team áp dụng phương pháp mới' },
      { txt: '└── templates/', type: 'manual', note: 'Template copy-paste để tạo file mới' },
    ],

    s2c_title: 'Skills & Workflows thiết yếu',
    s2c_sub: 'Định nghĩa trước Sprint 1 — hệ điều hành AI của team',
    s2c_skills_t: 'Danh mục Skill (AI có thể chuyên biệt hóa)',
    s2c_workflows_t: 'Slash commands cốt lõi (dùng hàng ngày)',
    s2c_skills: [
      { cat: 'Nền tảng (cài trước tiên)', items: ['find-skills', 'skill-creator', 'context-builder'], color: 'teal' },
      { cat: 'Coding', items: ['api-handler', 'component', 'service', 'database'], color: 'accent' },
      { cat: 'Testing', items: ['unit-test', 'e2e-playwright', 'test-plan'], color: 'teal' },
      { cat: 'Review', items: ['pr-checklist', 'code-review'], color: 'amber' },
      { cat: 'Infrastructure', items: ['security', 'docker', 'ci-cd'], color: 'purple' },
    ],
    s2c_workflows: [
      { cmd: '/find-skills [chủ đề]', desc: 'Tìm kiếm & khám phá các skills có sẵn' },
      { cmd: '/create-skill [tên]', desc: 'Tạo skill mới từ template' },
      { cmd: '/feature TASK-xxx', desc: 'Luồng triển khai TDD đầy đủ' },
      { cmd: '/fix TASK-xxx', desc: 'Sửa bug kèm regression test' },
      { cmd: '/review', desc: 'Checklist tự review PR' },
      { cmd: '/deploy [env]', desc: 'Deploy với các cổng kiểm tra trước' },
      { cmd: '/test [file]', desc: 'Sinh unit test' },
      { cmd: '/test-plan PRD-xxx', desc: 'Lập kế hoạch test từ spec trước' },
      { cmd: '/onboard TASK-xxx', desc: 'Tiếp nhận task từ ticket' },
      { cmd: '/e2e [scenario]', desc: 'Test E2E Playwright' },
      { cmd: '/init', desc: 'Scan bootstrap dự án' },
      { cmd: '/refactor [scope]', desc: 'Luồng refactor an toàn' },
    ],

    s3_title: 'IDE Tool Mapping',
    s3_sub: 'Claude Code · Cursor · Windsurf — cùng khái niệm, cú pháp khác nhau',
    s3_th: ['Khái niệm', 'Claude Code', 'Cursor', 'Windsurf'],
    s3_rows: [
      ['Always-on Rules', 'CLAUDE.md\n+ .claude/rules/*.md', '.cursor/rules/*.mdc\n(alwaysApply: true)', '.windsurfrules\nglobal_rules.md'],
      ['Path-scoped Rules', 'Subdirectory\nCLAUDE.md', '*.mdc với\nglob patterns', 'Workspace rules\n(glob mode)'],
      ['On-demand Skills', 'skills/\n(tự động kích hoạt)', 'rules/ với\n@ruleName manual', 'Memories\n(tự lưu/gọi lại)'],
      ['Slash Commands', 'commands/*.md', 'rules/ description\nfield', 'Workflows\n/workflow-name'],
      ['Auto Events', 'settings.json\nPre/PostToolUse', 'SKILL.md\nhooks', 'Auto-memory +\nTurbo mode'],
      ['Sub-agents', 'agents/*.md', 'Background\nAgents', 'Parallel\nCascades'],
      ['Cross-IDE', 'AGENTS.md (root)', 'AGENTS.md (root)', 'AGENTS.md (root)'],
      ['MCP', '.mcp.json', '.mcp.json', '.mcp.json'],
    ],

    s4_title: 'Project Bootstrap',
    s4_sub: 'Cài đặt một lần — hoàn thành trước Sprint 1',
    s4_lanes: ['Tech Lead', 'Dev Team', 'AI Agent', 'Output'],
    s4_steps: [
      { row: 0, lane: 0, text: 'Xác định tech stack\nbusiness domain\nquy ước coding', type: 'io' },
      { row: 0, lane: 2, text: '/init → scan codebase\nPhát hiện frameworks, patterns\ndependencies, test setup', type: 'step' },
      { row: 1, lane: 3, text: 'CLAUDE.md draft\nAGENTS.md draft', type: 'io' },
      { row: 1, lane: 0, text: 'Review draft\nThêm business context\nThêm NEVER-do rules\nGiữ < 200 dòng', type: 'gate' },
      { row: 2, lane: 3, text: 'CLAUDE.md v1 ✓\nAGENTS.md v1 ✓', type: 'note' },
      { row: 2, lane: 0, text: 'Tìm & cài base skills\ntừ skills.sh + official repos\n→ tùy chỉnh cho dự án', type: 'step' },
      { row: 2, lane: 2, text: 'Tùy chỉnh skills:\n+ patterns dự án\n+ mục Gotchas\n+ thư mục examples/', type: 'step' },
      { row: 3, lane: 3, text: '.claude/skills/ ✓\n.cursor/rules/ ✓', type: 'note' },
      { row: 3, lane: 0, text: 'Định nghĩa commands:\n/feature /fix\n/review /deploy', type: 'step' },
      { row: 3, lane: 2, text: 'Soạn command files\nCấu hình hooks trong\nsettings.json', type: 'step' },
      { row: 4, lane: 3, text: '.claude/commands/ ✓\nsettings.json ✓', type: 'note' },
      { row: 4, lane: 0, text: 'Commit .claude/ lên git\nToàn team clone → sẵn sàng', type: 'gate' },
      { row: 5, lane: 3, text: 'Toàn team sẵn sàng ✓', type: 'note' },
    ],

    s5_title: 'Daily Dev Loop',
    s5_sub: 'Swimlane phát triển feature — lặp lại mỗi ngày',
    s5_lanes: ['PM / BA', 'Dev', 'AI Agent', 'CI / CD', 'Output'],
    s5_steps: [
      { row: 0, lane: 0, text: 'Tạo ticket #101\nvới acceptance criteria', type: 'io' },
      { row: 0, lane: 1, text: '/onboard TASK-101', type: 'step' },
      { row: 0, lane: 2, text: 'Đọc ticket qua MCP\nScan file liên quan\nXác định điểm mơ hồ', type: 'step' },
      { row: 1, lane: 2, text: 'Đặt câu hỏi làm rõ', type: 'step' },
      { row: 1, lane: 0, text: 'Trả lời câu hỏi\nXác nhận phạm vi', type: 'gate' },
      { row: 1, lane: 3, text: 'CI khởi động', type: 'note' },
      { row: 2, lane: 2, text: 'Tạo TASK-101.md:\n• Mục tiêu + AC\n• Ghi chú kỹ thuật\n• Test scenarios', type: 'step' },
      { row: 2, lane: 1, text: 'Review task file ✓\n/feature TASK-101', type: 'gate' },
      { row: 2, lane: 2, text: 'Tải rules + skills\n→ PLAN MODE:\nđề xuất cách tiếp cận', type: 'step' },
      { row: 3, lane: 1, text: 'Duyệt kế hoạch\nhoặc điều chỉnh', type: 'gate' },
      { row: 3, lane: 2, text: '[HOOK: PreToolUse]\n→ Viết failing tests\n→ Triển khai\n[HOOK: PostToolUse]', type: 'hooks' },
      { row: 4, lane: 2, text: 'Tự review bằng\npr-checklist skill\nCập nhật log TASK-101', type: 'step' },
      { row: 4, lane: 1, text: 'Review diff\nTest AC thủ công\nPush PR', type: 'gate' },
      { row: 4, lane: 3, text: 'CI: unit tests\nlint · secret scan\ncoverage check', type: 'step' },
      { row: 4, lane: 4, text: 'Code ✓  Tests ✓\nPR ready ✓', type: 'io' },
    ],

    s5b_title: 'Prompt hàng ngày hiệu quả',
    s5b_sub: 'Nội dung cần đưa vào hướng dẫn để có output AI tốt nhất',
    s5b_anat_t: 'Giải phẫu một Prompt tốt',
    s5b_examples_t: 'Ví dụ thực tế (Copy & Paste)',
    s5b_anat: [
      { t: 'Context', d: 'Chúng ta đang làm gì? Files nào liên quan?' },
      { t: 'Hành động mục tiêu', d: 'AI cần làm chính xác điều gì? (/feature, /refactor)' },
      { t: 'Ràng buộc', d: 'Cần tránh gì? Tuân theo rules nào?' },
    ],
    s5b_examples: [
      { tag: 'Triển khai Feature', body: '/feature TASK-xxx\nVui lòng triển khai component UserProfile dựa trên PRD-001. Dùng Tailwind để styling. Không được mutation state trực tiếp; tuân theo React performance standards trong docs/rules/.' },
      { tag: 'Refactoring', body: '/refactor\nRefactor file này để tách logic data fetching thành custom React hook (useUserProfile). Giữ nguyên các test đang pass. Không thay đổi UI.' },
      { tag: 'Debugging', body: '/fix\nAPI trả về 401 khi token hết hạn. Xem auth.ts và axios interceptors. Thêm logic tự động refresh token dựa trên ADR-002-auth-strategy.md.' },
    ],

    s5c_title: 'Specs & Brainstorm Flow',
    s5c_sub: 'Từ ý tưởng đến yêu cầu đã chốt — AI là đối tác suy nghĩ của bạn',
    s5c_lanes: ['BA / PM', 'AI Assistant', 'Human Gate'],
    s5c_steps: [
      { lane: 0, row: 0, text: 'Viết brief feature ban đầu\nhoặc user story', type: 'io' },
      { lane: 1, row: 0, text: 'Phân tích brief → làm rõ ý định\n→ đề xuất use cases', type: 'step' },
      { lane: 2, row: 0, text: 'Reviewer: chấp nhận hoặc\nloại bỏ draft', type: 'gate' },
      { lane: 0, row: 1, text: 'Cung cấp context domain\n+ đối tượng mục tiêu + ràng buộc', type: 'step' },
      { lane: 1, row: 1, text: 'Sinh acceptance criteria\n+ edge cases + ngoài phạm vi', type: 'step' },
      { lane: 2, row: 1, text: 'Tech Lead review:\napprove AC → chốt PRD-xxx.md', type: 'gate' },
      { lane: 0, row: 2, text: 'PRD-xxx.md committed\nvào docs/requirements/', type: 'io' },
      { lane: 1, row: 2, text: 'Tự động sinh TASK-xxx.md\ntừ PRD', type: 'step' },
      { lane: 2, row: 2, text: 'Sprint sẵn sàng ✓\nBacklog đã cập nhật ✓', type: 'note' },
    ],
    s5c_tips: [
      'Đưa vào prompt: văn bản draft hiện tại · đối tượng mục tiêu · ràng buộc nghiệp vụ · điều AI không được tự giả định',
      'Ví dụ mở đầu: "Đây là PRD draft cho module thanh toán. Đối tượng: khách hàng B2B. Ràng buộc: phải tuân thủ PCI-DSS. Hãy xác định các yêu cầu còn thiếu và edge cases."',
      'AI làm tốt nhất: phát hiện yêu cầu mơ hồ · đề xuất test cases tiêu cực · soạn AC từ narrative · phát hiện mục tiêu mâu thuẫn',
    ],

    s5d_title: 'Coding Flow',
    s5d_sub: 'Task → Plan → Implement → Review — lập trình cặp với AI và guardrails',
    s5d_lanes: ['Human', 'Plan', 'Implement', 'Verify'],
    s5d_steps: [
      { lane: 0, row: 0, text: '/feature TASK-101\n(tải task file\n+ skills liên quan)', type: 'step' },
      { lane: 1, row: 0, text: 'AI đọc rules/\n+ skills/ → đề xuất cách tiếp cận', type: 'step' },
      { lane: 0, row: 1, text: 'Review kế hoạch:\nduyệt ✓ hoặc sửa ✗', type: 'gate' },
      { lane: 2, row: 1, text: 'AI viết failing\ntests trước (TDD)', type: 'step' },
      { lane: 2, row: 2, text: 'AI triển khai\nfeature để pass tests', type: 'step' },
      { lane: 3, row: 2, text: 'Hooks: tự format\nkiểm tra lint\n→ chặn nếu fail', type: 'hooks' },
      { lane: 0, row: 3, text: 'Human review diff\n+ kiểm tra AC → PR ready', type: 'gate' },
      { lane: 3, row: 3, text: 'CI: tests + scan\n→ merge nếu pass', type: 'io' },
    ],
    s5d_tips: [
      '/feature prompt: "Triển khai TASK-101. Tuân theo docs/rules/react-perf.md. Dùng hooks, không dùng class components. Ngoài phạm vi: payment logic. Dừng và hỏi trước khi chạm vào auth.ts."',
      '/fix prompt: "Bug: API trả 401 khi token hết hạn. Triệu chứng: trang login xuất hiện giữa phiên. Giả thuyết: interceptor không retry. Xem src/api/interceptors.ts trước."',
      '/refactor prompt: "Tách data-fetching từ UserProfile.tsx thành hook useUserProfile. Giữ nguyên tất cả tests đang pass. KHÔNG thay đổi bất kỳ JSX layout hoặc props interface nào."',
    ],

    s5e_title: 'Asking Flow',
    s5e_sub: 'Hiểu codebase mà không thay đổi nó',
    s5e_lanes: ['Developer', 'AI Agent', 'Gate'],
    s5e_steps: [
      { lane: 0, row: 0, text: 'Tải context files:\n@file.ts @ADR-00x.md', type: 'io' },
      { lane: 1, row: 0, text: 'Xác nhận phạm vi:\nhỏi nếu files cần làm rõ', type: 'step' },
      { lane: 0, row: 1, text: "Đặt câu hỏi:\n'X hoạt động như thế nào?'\n'Điều gì vỡ nếu tôi đổi Y?'", type: 'step' },
      { lane: 1, row: 1, text: 'Truy xuất luồng code từng bước\nDẫn số dòng cụ thể', type: 'step' },
      { lane: 2, row: 1, text: 'Dev kiểm tra câu trả lời AI\nvs code thực tế', type: 'gate' },
      { lane: 0, row: 2, text: 'Nếu sai: sửa + hỏi lại\nNếu đúng: tiến hành', type: 'step' },
      { lane: 1, row: 2, text: 'Không sinh code\n— chỉ trả lời', type: 'note' },
    ],
    s5e_tips: [
      'Luôn thêm "Không đề xuất thay đổi code" trong mọi prompt khám phá',
      'Luôn dùng tham chiếu @file — ngăn AI hallucinate về code chưa được xem',
      'Đừng chỉ hỏi CÁI GÌ — hỏi TẠI SAO. "Giải thích TẠI SAO token được lưu trong memory, không phải cookie"',
    ],

    s5f_title: 'Reviewing Flow',
    s5f_sub: 'AI pre-review trước human reviewers — output có cấu trúc',
    s5f_lanes: ['Developer', 'AI Agent', 'Human Reviewer'],
    s5f_steps: [
      { lane: 0, row: 0, text: 'Stage thay đổi:\ngit add -p (chọn lọc)', type: 'io' },
      { lane: 0, row: 1, text: 'Chạy: /review\n@docs/rules/code-style.md\n@docs/rules/security.md', type: 'step' },
      { lane: 1, row: 1, text: 'Phân tích staged diff\nĐối chiếu với rules + ADRs', type: 'step' },
      { lane: 1, row: 2, text: 'Output:\nBLOCKER (phải sửa)\nWARNING (cân nhắc)\nSUGGESTION (tùy chọn)', type: 'step' },
      { lane: 0, row: 2, text: 'Sửa tất cả BLOCKER\nPush + mở PR', type: 'gate' },
      { lane: 2, row: 3, text: 'Review:\nbusiness logic\nquyết định thiết kế', type: 'gate' },
      { lane: 2, row: 3, text: 'Merge ✓ hoặc yêu cầu thay đổi', type: 'io' },
    ],
    s5f_tips: [
      'AI kiểm tra: vi phạm rule · thiếu xử lý lỗi · vấn đề security · lệch naming/pattern',
      'Human tập trung vào: tính đúng đắn business logic · quyết định thiết kế · chia sẻ kiến thức · pattern mới',
      'Review prompt: "Review staged diff. Output: BLOCKER | WARNING | SUGGESTION. KHÔNG đánh dấu vấn đề style đã được Prettier xử lý."',
    ],

    s5g_title: 'Debugging Flow',
    s5g_sub: 'Điều tra bug có hệ thống — context có cấu trúc để chẩn đoán chính xác',
    s5g_lanes: ['Developer', 'AI Agent', 'Output'],
    s5g_steps: [
      { lane: 0, row: 0, text: 'Tái hiện bug\nthu thập: error + stack trace', type: 'io' },
      { lane: 0, row: 1, text: 'Tải: TASK-xxx.md\n+ files nghi ngờ + ADRs', type: 'step' },
      { lane: 0, row: 1, text: 'Nêu giả thuyết\n+ vùng an toàn (không được chạm X)', type: 'step' },
      { lane: 1, row: 2, text: 'Truy xuất call chain\nXác định nguyên nhân gốc\nĐề xuất các phương án sửa', type: 'step' },
      { lane: 0, row: 2, text: 'Xác nhận chẩn đoán\ntrước khi chấp nhận sửa', type: 'gate' },
      { lane: 1, row: 3, text: 'Triển khai sửa trong\nphạm vi vùng an toàn', type: 'step' },
      { lane: 2, row: 3, text: 'Chạy unit tests ✓\nThêm regression test ✓', type: 'io' },
    ],
    s5g_tips: [
      'Bug context: triệu chứng + thông báo lỗi (full stack trace) + bước tái hiện',
      'Giả thuyết: phỏng đoán tốt nhất của bạn — ngay cả giả thuyết sai cũng giúp AI thu hẹp nhanh hơn',
      'Vùng an toàn: "Không được sửa: LoginPage, authSlice.ts" — ngăn AI vượt phạm vi',
    ],

    s5h_title: 'Planning Flow',
    s5h_sub: 'Phân rã công việc thành task nhỏ, có thể kiểm chứng — input/output rõ ràng cho AI thực thi',
    s5h_lanes: ['Tech Lead / Dev', 'AI Agent', 'Gate'],
    s5h_steps: [
      { lane: 0, row: 0, text: 'Tải: PRD-xxx.md\n+ tài liệu kiến trúc\n+ tasks hiện có', type: 'io' },
      { lane: 0, row: 0, text: "Mô tả mục tiêu:\n'Build feature X'\nhoặc 'Refactor module Y'", type: 'step' },
      { lane: 1, row: 1, text: 'Chia thành sub-tasks\nmỗi task có:\n- Input files\n- Output files\n- Verify checklist', type: 'step' },
      { lane: 0, row: 1, text: 'Review task plan:\nMỗi task đã đủ nhỏ chưa?\n(< 1 phiên)', type: 'gate' },
      { lane: 1, row: 2, text: 'Cho mỗi sub-task:\nSinh TASK-xxx.md\nvới template đầy đủ', type: 'step' },
      { lane: 0, row: 2, text: 'Xác nhận: mỗi task\ncó AC + bước verify rõ ràng?', type: 'gate' },
      { lane: 2, row: 3, text: 'Kế hoạch đã duyệt →\nthực thi tasks theo thứ tự', type: 'io' },
    ],
    s5h_tips: [
      'Quy tắc kích thước: nếu AI cần >1 phiên, hãy chia nhỏ hơn. Mỗi task: 1 input → 1 output → 1 lệnh verify',
      'Task template: Mục tiêu · Input files · Output files · Acceptance Criteria · Lệnh verify',
      'Thứ tự phụ thuộc: sắp xếp tasks sao cho output của task này là input của task tiếp theo. Không có phụ thuộc vòng.',
    ],

    s6_title: 'Testing Workflow',
    s6_sub: 'Unit test · E2E Playwright · Test-first từ yêu cầu',
    s6_flows: [
      {
        t: 'Flow A: Unit Test',
        steps: [
          'Dev: /test [file]',
          'AI: tải unit-test skill, phân tích functions + error paths',
          'AI: sinh TEST PLAN (chưa có code — review trước)',
          'Dev: review plan ✓, thêm/bỏ scenarios',
          'AI: viết + chạy tests, sửa nếu fail',
          'HOOK: kiểm tra coverage — chặn nếu dưới ngưỡng',
          'Output: .test.ts ✓  Coverage ✓',
        ],
      },
      {
        t: 'Flow B: E2E Playwright',
        steps: [
          'Dev: /e2e "user checkout"',
          'AI: tải e2e skill, ánh xạ story → POM pages',
          'AI: tạo Page Objects, viết test scenarios',
          'AI: chạy headless — vòng lặp pass/fix',
          'CI: chạy E2E suite khi push lên staging',
          'Chặn merge nếu fail',
          'Output: .spec.ts ✓  CI report ✓',
        ],
      },
      {
        t: 'Flow C: Requirement → Tests',
        steps: [
          'BA: viết PRD-xxx.md với acceptance criteria',
          'Dev: /test-plan PRD-xxx',
          'AI: trích xuất AC → sinh positive + negative + edge',
          'Dev: review test plan ✓ (phát hiện điểm mơ hồ!)',
          'BA: làm rõ điểm mơ hồ',
          'AI: viết failing tests (stubs)',
          'Dev: triển khai → tests dần pass → tất cả xanh ✓',
        ],
      },
    ],

    s7_title: 'Team Standardisation',
    s7_sub: 'Đảm bảo mọi developer tạo ra output nhất quán, có thể tái sử dụng',
    s7_problem_t: 'Trạng thái bị vỡ',
    s7_problem: [
      'Dev A (Cursor) → phong cách X',
      'Dev B (Claude Code) → phong cách Y',
      'Dev C (không có rules) → phong cách Z',
      '→ Mất thêm thời gian review',
      '→ Thiếu nhất quán ngày càng tăng',
      '→ Onboarding khó khăn',
    ],
    s7_solution_t: 'Giải pháp: 4 tầng chuẩn dùng chung',
    s7_solution: [
      'Tầng 1 — Source of Truth: team-ai-standards/ git repo dùng chung (AGENTS.md + rules/ + skills/ + templates/)',
      'Tầng 2 — Gold Standard: gold-standard/examples/ (api-handler.ts, unit.test.ts hoàn hảo để AI học từ đó)',
      'Tầng 3 — Enforce qua Hooks + CI: pre-commit gitleaks, PostToolUse tự format, CI lint/naming/coverage gates',
      'Tầng 4 — Skill & Docs PR process: mọi thay đổi qua PR, Tech Lead review, merged → team tự cập nhật',
      'Output Consistency Checklist: naming · pattern · xử lý lỗi · commit convention · task log · API contract · ADR',
    ],

    s8_title: 'Security: Credentials & Secrets',
    s8_sub: 'Defense-in-depth — không bao giờ dựa vào một tầng duy nhất',
    s8_layers: [
      { t: 'Tầng 1 — Kiến trúc', d: 'Dùng secrets manager (AWS / Azure KV / Vault). .env.example committed (không có giá trị thật). .env.local gitignored.' },
      { t: 'Tầng 2 — Git', d: '.gitignore: .env .env.* *.pem *.key secrets/ credentials.json CLAUDE.local.md .claude/memory.json · pre-commit: gitleaks scan' },
      { t: 'Tầng 3 — Permissions (settings.json)', d: 'deny: ["Read(./.env)","Read(./secrets/**)","Bash(curl *)","Bash(cat *.env)"]' },
      { t: 'Tầng 4 — Hooks', d: 'security-hook.sh: chặn AI nếu cố đọc .env / *.key / ~/.aws. Exit 2 + thông báo.' },
      { t: 'Tầng 5 — CI/CD Gate', d: 'gitleaks + Trufflehog trên mỗi PR. Chặn merge nếu phát hiện pattern secret.' },
      { t: 'Tầng 6 — Rules + Training', d: 'rules/security.md: không bao giờ hardcode. Luôn dùng process.env.X. AI tự scan sk-, api_key=, password=.' },
    ],
    s8_rules_t: 'rules/security.md — AI phải tuân theo',
    s8_rules: [
      'KHÔNG BAO GIỜ viết API keys / passwords inline — dùng process.env.VARIABLE_NAME',
      'LUÔN thêm biến mới vào .env.example (không có giá trị thật), document trong README',
      'Tự scan toàn bộ code được sinh ra để tìm: sk-, pk_, api_key=, password=, secret=, token=',
      'Nếu phát hiện pattern secret trong output — DỪNG, refactor sang env var, báo cáo',
      'KHÔNG BAO GIỜ đọc file .env — chỉ tham chiếu docs/context/ cho cấu trúc env',
    ],

    s9_title: 'Input / Output Map',
    s9_sub: 'Mỗi giai đoạn — ai làm gì, đầu vào là gì, đầu ra là gì',
    s9_th: ['Giai đoạn', 'Human Input', 'AI thực hiện', 'Human Gate', 'Output'],
    s9_rows: [
      ['Knowledge\nFoundation', 'Codebase\ntài liệu thô\nkiến thức trong đầu người', '/init → trích xuất patterns\nSinh CLAUDE.md draft', 'Review + approve\nThêm context', 'docs/ folder\nCLAUDE.md v1'],
      ['Bootstrap', 'Tech stack\nquy ước\ncommunity repos', 'Tùy chỉnh skills\nSoạn commands + hooks', 'Review skills\nTest commands\nApprove hooks', '.claude/skills/\n.claude/commands/\nsettings.json'],
      ['Task\nIntake', 'Ticket URL hoặc brief', 'Đọc ticket qua MCP\nHỏi làm rõ\nTạo task file', 'Review task file\nApprove', 'TASK-xxx.md\ndocs/tasks/'],
      ['Design', 'Task file đã duyệt', 'Đề xuất cách tiếp cận\nKiểm tra vs ADRs\nLiệt kê files cần sửa', 'Duyệt kế hoạch\nhoặc điều chỉnh', 'Design notes\nTask file đã cập nhật'],
      ['Implement', '/feature TASK-xxx', 'Tải skills + rules\nTDD: tests trước\nTriển khai + tự review', 'Review diff\nTest AC thủ công', 'Source code\nUnit tests\nTask log đã cập nhật'],
      ['Testing', '/test [file]\n/e2e [scenario]', 'Sinh test plan\nChờ duyệt\nViết + chạy tests', 'Review scenarios\nApprove', 'Test files\nCoverage report'],
      ['Deploy', '/deploy [env]', 'Checklist pre-deploy\nE2E trên staging\nSecret scan\nRelease notes', 'Final approve', 'Deploy log\nKết quả E2E\nRelease notes'],
      ['Improve', 'Bất kỳ lúc nào\n(bugs, patterns, công cụ mới)', 'Đề xuất cập nhật cho\npatterns / lỗi lặp lại', 'Review + merge\ncải tiến', 'CLAUDE.md đã cập nhật\nSkills mới/đã cập nhật'],
    ],

    s10_title: 'Continuous Improvement Loop',
    s10_sub: 'Luôn hoạt động — không có lịch cố định, kích hoạt bởi sự kiện thực tế',
    s10_not_t: 'KHÔNG phải thế này',
    s10_not: [
      'Không có sprint review cho docs',
      'Không có họp cập nhật hàng tuần',
      'Không có lịch bảo trì rules định kỳ',
    ],
    s10_triggers_t: 'Các trigger theo sự kiện',
    s10_triggers: [
      'AI lặp lại cùng một lỗi 2+ lần → cập nhật ngay Gotchas trong skill',
      'Dev giải thích cùng context nhiều lần → thêm vào CLAUDE.md hoặc skill',
      'Phát hiện pattern tốt hơn → cập nhật skill, commit, team tự nhận',
      'Công cụ / model mới ra → đánh giá, cập nhật workflow nếu cần',
      'Bug hoặc sự cố bảo mật → thêm vào known-issues.md / cập nhật security rule',
      'Tech Lead sở hữu CLAUDE.md · Senior Dev sở hữu skills cụ thể · Mọi Dev báo cáo Gotchas qua PR · AI chủ động đề xuất cải tiến',
    ],
  },
};
